var map = {
	"./404/404": 8,
	"./404/404.vue": 8,
	"./archive/archive": 26,
	"./archive/archive.vue": 26,
	"./archive/archiveTemplate": 9,
	"./archive/archiveTemplate.vue": 9,
	"./archive/news/postLink": 10,
	"./archive/news/postLink.vue": 10,
	"./archive/pagenation": 11,
	"./archive/pagenation.vue": 11,
	"./archive/posts/postLink": 5,
	"./archive/posts/postLink.vue": 5,
	"./archive/publications/postLink": 12,
	"./archive/publications/postLink.vue": 12,
	"./common/breadcrumb": 13,
	"./common/breadcrumb.vue": 13,
	"./common/htmlRenderer": 14,
	"./common/htmlRenderer.vue": 14,
	"./common/identity": 15,
	"./common/identity.vue": 15,
	"./common/primaryNav": 16,
	"./common/primaryNav.vue": 16,
	"./common/secondaryNav": 17,
	"./common/secondaryNav.vue": 17,
	"./common/siteFooter": 18,
	"./common/siteFooter.vue": 18,
	"./common/siteHeader": 19,
	"./common/siteHeader.vue": 19,
	"./common/spinner": 4,
	"./common/spinner.vue": 4,
	"./page/about/header": 20,
	"./page/about/header.vue": 20,
	"./page/about/latest": 21,
	"./page/about/latest.vue": 21,
	"./page/about/members": 22,
	"./page/about/members.vue": 22,
	"./page/about/pageTemplate": 23,
	"./page/about/pageTemplate.vue": 23,
	"./page/page": 28,
	"./page/page.vue": 28,
	"./page/top/pageTemplate": 24,
	"./page/top/pageTemplate.vue": 24,
	"./single/single": 29,
	"./single/single.vue": 29,
	"./single/singleTemplate": 25,
	"./single/singleTemplate.vue": 25
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;



//////////////////
// WEBPACK FOOTER
// ./src/components ^\.\/.*$
// module id = 30
// module chunks = 1